import script from "./footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./footer.vue?vue&type=script&setup=true&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=024e8003&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-024e8003"]])

export default __exports__